import { render } from "./AccessModuleComponent.vue?vue&type=template&id=261dc541&scoped=true"
import script from "./AccessModuleComponent.vue?vue&type=script&lang=js"
export * from "./AccessModuleComponent.vue?vue&type=script&lang=js"

import "./AccessModuleComponent.vue?vue&type=style&index=0&id=261dc541&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261dc541"]])

export default __exports__